module.exports = __webpack_public_path__ + "assets/img/tx20g_1.6b680119.jpg";